import actions from '../../store/actions'
import { useState } from 'react'
import { queries } from '../../resources'
import { generateError } from '../../helpers/errors'
import { MenuEntriesRequest, MenuEntriesResponse } from '../../resources/establishment/types'
import { useDispatch } from '../redux'

export const useGetMenuEntries = () => {
    const dispatch = useDispatch()
    const [inProgress, setInProgress] = useState(false)

    const getMenuEntries = (payload: MenuEntriesRequest): Promise<MenuEntriesResponse> => {
        setInProgress(true)
        return queries
            .getMenuEntries(payload)
            .then((response) => {
                dispatch(actions.setMenuEntries(response))
                setInProgress(false)
                return response
            })
            .catch((error) => {
                throw generateError(error)
            })
    }

    return {
        getMenuEntries,
        inProgress,
    }
}
